import { MapOutlined, InfoOutlined, ImageOutlined, ThreeSixty } from '@material-ui/icons';
import React, { Fragment, ReactElement, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AppContext } from '../../../../state/app.state';
import { Map } from '@material-ui/icons';
import SideBarButton from '../SidebarButton/SideBarButton';
import { hasNavigator } from '../../../../App';
import { isMobile } from '../../../../utils/app.helper';
import BrandingService from '../../../../services/branding.service';
import { VideoFileCollectionItemT } from 'bovaljaren-models';
import { ObjectViewButton } from '../../../views/ObjectView/Desktop/ObjectViewButtons/ObjectViewButtons';

export type SidebarButtonsT = {
    label: string;
    imgSrc?: string;
    onClick?: () => void;
    alt: string;
    iconElement?: JSX.Element
    shouldRender: boolean;
}[]


const SideBarButtonGroup: React.FC<{projectId?: number; sidebarButtons?: {count: number, buttons: SidebarButtonsT}}> = ({ projectId, sidebarButtons }): ReactElement => {


    const { presentationState, state, handleSharing } = useContext(AppContext);



    const getSideBarButtons = (): {count: number, buttons: SidebarButtonsT} => {
        if (sidebarButtons) return sidebarButtons;

        const buttons: SidebarButtonsT = [
            {
                label: state?.project?.config?.videoLabel || 'Video',
                alt: 'Ikon för Video',
                shouldRender: !!state?.project?.videoId,
                onClick: (): void => {
                    presentationState?.setShowVideo(state?.project?.video || undefined);
                }
            },
            {
                label: state?.currentView?.config?.videoLabel || 'Video',
                alt: 'Ikon för Video',
                shouldRender: !!state?.currentView?.videoId,
                onClick: (): void => {
                    presentationState?.setShowVideo(state?.currentView?.video || undefined);
                }
            },
            {
                label: 'Solstudie',
                alt: 'Ikon för Video',
                shouldRender: !!state?.project?.solarStudyId && !!state?.project?.solarStudy && state?.project?.solarStudy.files.length > 0,
                onClick: (): void => {
                    presentationState?.setShowSunStudyModal(state?.project?.solarStudy || undefined);
                }
            },
            {
                label: 'Solstudie',
                alt: 'Ikon för Video',
                shouldRender: !!state?.currentView?.solarStudyId && !!state?.currentView?.solarStudy && state?.currentView?.solarStudy.files.length > 0,
                onClick: (): void => {
                    presentationState?.setShowSunStudyModal(state?.currentView?.solarStudy || undefined);
                }
            },
            {
                label: state?.project?.tours.find(t => t.id === state.project?.iframeOneId)?.label || '',
                alt: 'Projekt iframe 1',
                shouldRender: !!state?.project?.tours.find(t => t.id === state.project?.iframeOneId),
                onClick: (): void => {
                    presentationState?.setCurrentIframe(state?.project?.tours.find(t => t.id === state.project?.iframeOneId));
                }
            },
            {
                label: state?.project?.tours.find(t => t.id === state.project?.iframeTwoId)?.label || '',
                alt: 'Projekt iframe 2',
                shouldRender: !!state?.project?.tours.find(t => t.id === state.project?.iframeOneId),
                onClick: (): void => {
                    presentationState?.setCurrentIframe(state?.project?.tours.find(t => t.id === state.project?.iframeTwoId));
                }
            },
            {
                label: state?.project?.tours.find(t => t.id === state.currentView?.iframeOneId)?.label || '',
                alt: 'View iframe 1',
                shouldRender: !!state?.project?.tours.find(t => t.id === state.currentView?.iframeOneId),
                onClick: (): void => {
                    presentationState?.setCurrentIframe(state?.project?.tours.find(t => t.id === state.currentView?.iframeOneId));
                }
            },
            {
                label: state?.project?.tours.find(t => t.id === state.currentView?.iframeTwoId)?.label || '',
                alt: 'View iframe 2',
                shouldRender: !!state?.project?.tours.find(t => t.id === state.currentView?.iframeTwoId),
                onClick: (): void => {
                    presentationState?.setCurrentIframe(state?.project?.tours.find(t => t.id === state.currentView?.iframeTwoId));
                }
            },
            {
                label: 'Bilder',
                alt: 'Ikon för Bilder',
                shouldRender: !!state?.project?.imageCollectionId && !!state?.project?.imageCollection?.files && state?.project?.imageCollection?.files?.length > 0,
                onClick: (): void => {
                    presentationState?.setShowImageGalleryModal(state?.project?.imageCollection || undefined);
                }
            },
            {
                label: 'Bilder',
                alt: 'Ikon för Bilder',
                shouldRender: !!state?.currentView?.imageCollectionId && !!state?.currentView?.imageCollection?.files && state?.currentView?.imageCollection?.files?.length > 0,
                onClick: (): void => {
                    presentationState?.setShowImageGalleryModal(state?.currentView?.imageCollection || undefined);
                }
            },
            {
                label: 'Sparade',
                alt: 'Ikon för favoriter',
                shouldRender: state?.project?.config?.favorites || false,
                onClick: (): void => presentationState?.setShowFavoriteModal(!presentationState?.showFavoriteModal)
            },
            {
                label: 'Dela',
                alt: 'Ikon för delning',
                shouldRender: state?.project?.config?.shareProject || false,
                onClick: (): void => {

                    if (isMobile() && window.navigator && state?.shareLink) {
                        handleSharing(`Besök ${state.project?.name}!`, `https://${window.location.hostname}/bv/v3/project/${projectId || ''}`);
                    }
                    else {
                        state?.setShareLink && state.setShareLink({ value: `https://${window.location.hostname}/bv/v3/project/${projectId || ''}` });
                        presentationState?.setShowShareModal(true);
                    }
                }
            }];

        return ({ buttons, count: buttons.filter(b => b.shouldRender).length });
    };

    return (
        <>
            {getSideBarButtons().count > 0 &&
            <div className="bv-objectview-buttons">
                {getSideBarButtons().buttons.filter(({ shouldRender }) => !!shouldRender).map(({ label, alt, imgSrc, iconElement, onClick }, index) => {
                    return (
                        <ObjectViewButton key={index + label} label={label} onClick={onClick}/>);
                })}
            </div>}
        </>
    );
};


export default SideBarButtonGroup;

